import { render, staticRenderFns } from "./SectionModal.vue?vue&type=template&id=32786c40"
import script from "./SectionModal.vue?vue&type=script&lang=js"
export * from "./SectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports